import type { SVGProps } from "react";

/**
 * Small control glyphs for the select caret, the checkmarks and the tab scroll
 * arrows. The artwork (16px tall boxes, 1.5 stroke) is the
 * Digital HIG ui-controls set, kept as is: `@weave-brand/icon` has the same
 * names but on a 24px grid with different paths, which sits differently in the
 * controls. Strokes use `currentColor`, so the parent sets the colour. The
 * `id`s on the group and path are kept as they were: Weave's `MuiSvgIcon`
 * theme styles `g#error`, so ids on these glyphs are load-bearing.
 */
type IconProps = SVGProps<SVGSVGElement>;

const stroke = {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
} as const;

export const CaretDown = (props: IconProps) => (
  <svg
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="caret-down">
      <path id="stroke" d="M11.001 5.5L6.00098 10.5L1.00098 5.5" {...stroke} />
    </g>
  </svg>
);

export const Checkmark = (props: IconProps) => (
  <svg
    viewBox="0 0 11 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="checkmark">
      <path id="stroke" d="M1 7.40791L4.18182 11.0005L10 4.5005" {...stroke} />
    </g>
  </svg>
);

export const Indeterminate = (props: IconProps) => (
  <svg
    viewBox="0 0 10 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="indeterminate">
      <path id="stroke" d="M1 8L9 8.00001" {...stroke} />
    </g>
  </svg>
);

export const CaretLeft = (props: IconProps) => (
  <svg
    viewBox="0 0 7 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="caret-left">
      <path id="stroke" d="M6.00098 3L1.00098 8L6.00098 13" {...stroke} />
    </g>
  </svg>
);

export const CaretRight = (props: IconProps) => (
  <svg
    viewBox="0 0 7 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="caret-right">
      <path id="stroke" d="M1.00101 3L6.00101 8L1.00101 13" {...stroke} />
    </g>
  </svg>
);
